import React from 'react';

const Timeline: React.FC = () => {
    const items = [
        { time: '14:00 — 15:00', title: 'Сбор гостей', desc: 'Встреча гостей, лёгкие напитки и фуршет' },
        { time: '16:00', title: 'Церемония', desc: 'Торжественная регистрация брака' },
        { time: '17:00', title: 'Банкет', desc: 'Праздничный ужин и развлечения' },
        { time: '20:00 — 21:00', title: 'Торт', desc: 'Вынос свадебного торта' },
        { time: '23:00', title: 'Окончание свадебной программы', desc: 'Прощание с молодоженами' },
    ];

    return (
        <section className="bg-cream py-24 md:py-32 px-4">
            <div className="max-w-2xl mx-auto">
                <p className="font-sans text-[10px] md:text-xs tracking-[0.4em] uppercase text-gold mb-4">
                    расписание
                </p>
                <h2 className="font-script text-4xl md:text-6xl text-prussian_blue mb-6">Программа дня</h2>
                <div className="flex items-center justify-center gap-3 mb-14 divider-ornament max-w-xs mx-auto">
                    <span className="text-gold text-xl animate-heart">♥</span>
                </div>
                <div className="relative">
                    <div className="absolute left-1/2 -translate-x-px top-0 bottom-0 w-px timeline-line" />
                    {items.map((item, i) => (
                        <div
                            key={item.time}
                            className={`relative flex items-center mb-12 last:mb-0 ${
                                i % 2 === 0 ? 'flex-row' : 'flex-row-reverse'
                            }`}>
                            <div className={`w-6/12 ${i % 2 === 0 ? 'text-right pr-8' : 'text-left pl-8'}`}>
                                <span className="font-serif text-lg md:text-xl text-prussian_blue font-semibold">
                                    {item.time}
                                </span>
                            </div>
                            <div className="w-1/12 flex justify-center">
                                <div className="timeline-dot w-3.5 h-3.5 rounded-full z-10" />
                            </div>
                            <div className={`w-6/12 ${i % 2 === 0 ? 'text-left pl-8' : 'text-right pr-8'}`}>
                                <h4 className="font-serif text-base md:text-lg text-prussian_blue font-semibold">{item.title}</h4>
                                <p className="font-sans text-xs md:text-sm text-prussian_blue/50 mt-1 leading-relaxed">{item.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Timeline;

